import request from '@/utils/request';
import Vue from 'vue';

// 登录方法
export function login(username, password, code, key, is_keeplogin) {
  const data = {
    username,
    password,
    is_keeplogin,
    code,
    key,
  };
  return request({
    url: Vue.prototype.$api.login.index,
    headers: {
      isToken: false,
    },
    method: 'post',
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: Vue.prototype.$api.login.userinfo,
    method: 'post',
  });
}

//修改用户信息
export function setUserInfo(data) {
  return request({
    url: Vue.prototype.$api.user.setUserInfo,
    method: 'post',
    data,
  });
}

// 更新个人信息
export function update(data) {
  return request({
    url: Vue.prototype.$api.login.update,
    method: 'post',
    data,
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: Vue.prototype.$api.login.getCaptcha,
    method: 'get',
    responseType: 'arraybuffer',
  });
}

// 获取短信验证码
export function getPhoneCode(params) {
  return request({
    url: Vue.prototype.$api.login.send,
    method: 'get',
    params,
  });
}

//验证码登录
export function codeLogin(data) {
  return request({
    url: Vue.prototype.$api.login.codeIndex,
    method: 'post',
    data,
  });
}

//注册
export function regist(data) {
  return request({
    url: Vue.prototype.$api.login.regist,
    method: 'post',
    data,
  });
}
// 修改密码
export function reset(data) {
  return request({
    url: Vue.prototype.$api.login.reset,
    method: 'post',
    data,
  });
}

// 完善信息
export function addInfo(data) {
  return request({
    url: Vue.prototype.$api.login.add,
    method: 'post',
    data,
  });
}

// 退出方法
export function logout() {
  return request({
    url: Vue.prototype.$api.login.logout,
    method: 'get',
  });
}

export function getAreaList(params) {
  return request({
    url: Vue.prototype.$api.user.getArea,
    method: 'get',
    params,
  });
}

//获取收货地址列表

export function getAddressList(params) {
  return request({
    url: '/api/user.address/index',
    method: 'get',
    params,
  });
}


export function addAddress(data) {
  return request({
    url: '/api/user.address/add',
    method: 'post',
    data,
  });
}

export function deleteAddress(params) {
  return request({
    url: '/api/user.address/delete',
    method: 'get',
    params,
  });
}

export function eidtAddress(data) {
  return request({
    url: '/api/user.address/edit',
    method: 'post',
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js